import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './notification-modal.component.html',
  styleUrl: './notification-modal.component.scss',
  standalone: false,
})
export class NotificationModalComponent {
  title: string = null;
  notificationType: string = null;
  description: string = null;
  description2: string = null;
  description3: string = null;
  question: string = null;
  question2: string = null;
  notificationInfo: string = null;
  confirmBtn: string = null;
  isCloseButtonHidden: boolean;
  cancelBtn: string = null;
  cssClass: string;
  icon: any;
  centerHeader: boolean = false;
  noHeaderBorder: boolean = false;
  noteInfo: any;
  iconSize: any = 24;
  descriptionMeta: any;
  closeModalHandlerResult: any;
  hideButton: any;
  title2: any;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly route: Router
  ) {}

  public setParams(data: Record<string, any>): void {
    this.assignStringProperties(data);
    this.assignBooleanProperties(data);
    this.assignanyProperties(data);
    this.assignSpecialProperties(data);
    this.cssClass = data.cssClass ? (data.cssClass as string) : 'default';
  }

  private assignStringProperties(data: Record<string, any>): void {
    const stringProps: Array<{ key: string; target: keyof NotificationModalComponent }> = [
      { key: 'title', target: 'title' },
      { key: 'description', target: 'description' },
      { key: 'description2', target: 'description2' },
      { key: 'description3', target: 'description3' },
      { key: 'confirmBtn', target: 'confirmBtn' },
      { key: 'notificationInfo', target: 'notificationInfo' },
      { key: 'question', target: 'question' },
      { key: 'question2', target: 'question2' },
      { key: 'cancelBtn', target: 'cancelBtn' },
      { key: 'notificationType', target: 'notificationType' },
    ];

    stringProps.forEach((prop: { key: string; target: keyof NotificationModalComponent }) => {
      if (data[prop.key]) {
        (this[prop.target] as string) = data[prop.key] as string;
      }
    });
  }

  private assignBooleanProperties(data: Record<string, any>): void {
    if (data.centerHeader) {
      this.centerHeader = true;
    }
    if (data.isCloseButtonHidden !== undefined) {
      this.isCloseButtonHidden = data.isCloseButtonHidden as boolean;
    }
    if (data.noHeaderBorder !== undefined) {
      this.noHeaderBorder = data.noHeaderBorder as boolean;
    }
  }

  private assignanyProperties(data: Record<string, any>): void {
    const anyProps: Array<{ key: string; target: keyof NotificationModalComponent }> = [
      { key: 'title2', target: 'title2' },
      { key: 'icon', target: 'icon' },
      { key: 'noteInfo', target: 'noteInfo' },
      { key: 'descriptionMeta', target: 'descriptionMeta' },
      { key: 'closeModalHandlerResult', target: 'closeModalHandlerResult' },
      { key: 'hideButton', target: 'hideButton' },
    ];

    anyProps.forEach((prop: { key: string; target: keyof NotificationModalComponent }) => {
      if (data[prop.key]) {
        (this as Record<string, any>)[prop.target] = data[prop.key];
      }
    });
  }

  private assignSpecialProperties(data: Record<string, any>): void {
    if (data.iconSize) {
      this.iconSize = data.iconSize;
    }
  }

  public onConfirmModal(): void {
    if (this.title === 'User Blocked') {
      this.activeModal.close({ reason: 'OK' });
      this.route.navigate(['/projects']);
    } else {
      this.activeModal.close(this.closeModalHandlerResult ? { reason: 'OK' } : true);
    }
  }

  public onCancelModal(reason: string): void {
    this.activeModal.close(this.closeModalHandlerResult ? { reason } : false);
  }
}
